import { ArrowLeft, CheckCircle } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const RappelSuppressionPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const requestId = searchParams.get('id');

  return (
    <div className="min-h-screen bg-[#09090b]">
      <header className="sticky top-0 z-50 bg-[#09090b]/95 backdrop-blur-md border-b border-zinc-800">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-3">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-zinc-400 hover:text-white transition">
            <ArrowLeft className="w-5 h-5" />
            <img src="/logo-youmi.png" alt="YOUMI GREEN VTC" className="w-10 h-10" />
            <span className="text-lg font-bold text-white font-['Outfit']">YOUMI <span className="text-emerald-500">GREEN</span></span>
          </button>
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-4 py-12">
        <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-8 text-center">
          <CheckCircle className="w-16 h-16 text-emerald-500 mx-auto mb-6" />
          <h1 className="text-2xl font-bold text-white font-['Outfit'] mb-4" data-testid="rappel-suppression-title">{t('callback_title')}</h1>
          <p className="text-zinc-300 leading-relaxed max-w-lg mx-auto">
            {t('callback_text')} <strong className="text-white">{t('callback_days')}</strong>.
          </p>
          {requestId && (
            <div className="mt-6 bg-zinc-800/50 border border-zinc-700 rounded-lg p-4 inline-block">
              <p className="text-zinc-400 text-sm">{t('callback_request_id')}</p>
              <p className="text-white font-mono text-lg font-semibold mt-1" data-testid="request-id">{requestId}</p>
            </div>
          )}
          <div className="mt-8 space-y-3 text-zinc-400 text-sm max-w-md mx-auto text-left">
            <p>{t('callback_id_info')}</p>
            <p>{t('callback_contact_info')} <a href="mailto:contact@youmigreenvtc.com" className="text-emerald-400 hover:underline ml-1">contact@youmigreenvtc.com</a></p>
          </div>
          <button onClick={() => navigate('/')} className="mt-8 px-6 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg transition-colors text-sm font-medium" data-testid="back-home-btn">
            {t('callback_back')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RappelSuppressionPage;
